module.exports = __webpack_public_path__ + "img/imgmaoxzt-1.75f78953.png";